import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../../Api';
import {
} from '../actions/categories';
import {
  GET_ARTICLE_BLOCKS_FAIL,
  GET_ARTICLE_BLOCKS_REQUEST,
  GET_ARTICLE_BLOCKS_SUCCESS, GET_ARTICLES_FAIL,
  GET_ARTICLES_REQUEST, GET_ARTICLES_SUCCESS,
} from '../actions/articles';

export default function* watcher() {
  yield takeLatest(GET_ARTICLE_BLOCKS_REQUEST, getArticleBlocks);
  yield takeLatest(GET_ARTICLES_REQUEST, getArticles);
}

function* getArticleBlocks(action) {
  try {
    const { data } = yield call(Api.getArticleBlocks, action.payload);

    yield put({
      type: GET_ARTICLE_BLOCKS_SUCCESS,
      payload: data.articleBlocks,
    });
  } catch (error) {
    console.warn(error, 'while getting article blocks');
    yield put({
      type: GET_ARTICLE_BLOCKS_FAIL,
      payload: error,
    });
  }
}

function* getArticles(action) {
  try {
    const { data } = yield call(Api.getArticles, action.payload);

    yield put({
      type: GET_ARTICLES_SUCCESS,
      payload: data.articles,
    });
  } catch (error) {
    console.warn(error, 'while getting articles');
    yield put({
      type: GET_ARTICLES_FAIL,
      payload: error,
    });
  }
}
